import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNaviconHomeActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.0361 9H9.53613C9.12192 9 8.78613 9.33579 8.78613 9.75V15.75C8.78613 16.1642 9.12192 16.5 9.53613 16.5H16.0361C16.4503 16.5 16.7861 16.1642 16.7861 15.75V9.75C16.7861 9.33579 16.4503 9 16.0361 9Z",
			fill: "#F9BCFF",
			stroke: "#C948D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.0361 19H9.53613C9.12192 19 8.78613 19.3358 8.78613 19.75V26.25C8.78613 26.6642 9.12192 27 9.53613 27H16.0361C16.4503 27 16.7861 26.6642 16.7861 26.25V19.75C16.7861 19.3358 16.4503 19 16.0361 19Z",
			stroke: "#EAAFEF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.0361 19H9.53613C9.12192 19 8.78613 19.3358 8.78613 19.75V26.25C8.78613 26.6642 9.12192 27 9.53613 27H16.0361C16.4503 27 16.7861 26.6642 16.7861 26.25V19.75C16.7861 19.3358 16.4503 19 16.0361 19Z",
			stroke: "#EAAFEF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.2471 19H19.7471C19.3329 19 18.9971 19.3358 18.9971 19.75V26.25C18.9971 26.6642 19.3329 27 19.7471 27H26.2471C26.6613 27 26.9971 26.6642 26.9971 26.25V19.75C26.9971 19.3358 26.6613 19 26.2471 19Z",
			stroke: "#EAAFEF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.25 9H19.75C19.3358 9 19 9.33579 19 9.75V15.75C19 16.1642 19.3358 16.5 19.75 16.5H26.25C26.6642 16.5 27 16.1642 27 15.75V9.75C27 9.33579 26.6642 9 26.25 9Z",
			stroke: "#EAAFEF"
		})
	]
});
export default SvgNaviconHomeActive;
